import React from 'react';
import { LinearProgress } from 'material-ui/Progress';
import {
    Button,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    Grid,
    TextField,
    Typography,
    withStyles,
} from 'material-ui';

import { DatePicker } from 'material-ui-pickers';

import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import EventIcon from 'material-ui-icons/Event';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import DropDownMenu from '../../ui/DropDownMenu';
import InvoicesTable from './Table/InvoicesTable';
import { getInvoiceByLocalizador, getInvoicePDFByLocalizador, listInvoices } from './invoicesServices';
import moment from 'moment';
import Breadcrumbs from '../../ui/Breadcrumbs';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { handleDateChange } from '../Utils/handleDateChange';
import { translate } from 'react-i18next';

import { isEdge } from '../../services/browserDetector';

const styles = theme => ({
    column: {
        flexBasis: '33.33%',
    },
    columnall: {
        flexBasis: '77.77%',
        marginRight: '64px',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: 'var(--secondary-button-color)',
    },
    filterTitle: {
        color: theme.palette.primary.contrastText,
        fontSize: '16px'
    },
    expansionPanelFilter: {
        backgroundColor: theme.palette.primary.main,
    },
    expansionIcon: {
        color: theme.palette.primary.contrastText,
    },
    coloredIcon: {
        color: 'var(--primary-color) !important',
        marginRight: '-24px'
    },
    coloredIconIE: {
        color: 'var(--primary-color) !important',
        marginTop: '-20px',
        paddingBottom: '5px'
    },
});
/**
 * Componente que lista mis reservas
 */
class Invoices extends OLYWebPageComponent {
    searchLocalizador = event => {

        if (this.cantSearchById()) {
            alert(this.props.t('INVOICES.INSERT_LOCATOR'));
        }
        else {
            this.setState({ loading: true });
            getInvoiceByLocalizador(this.state.localizadorID)
                .then(invoices => {
                    let data = [];
                    if (invoices && invoices.message) {
                        alert(invoices.message);
                    } else {
                        if (Array.isArray(invoices)) {
                            data = invoices;
                        } else {
                            data = [];
                        }
                        this.setState({
                            loading: false,
                            data: data,
                        });
                        if (data.length < 1) {
                            alert(this.props.t('INVOICES.NOT_FOUND'));
                        }
                    }
                })
                .catch(reason => {
                    alert(this.props.t('INVOICES.NOT_FOUND'));
                    this.setState({ loading: false, data: [] });
                });
        }
    };

    componentDidMount() {
        super.componentDidMount();
        this.fetchBackendData();
    }

    tableActionsMenuHandler = (factura, action) => {
        //reserva, action
        getInvoicePDFByLocalizador(factura.print_url)
            .then(result => {
                window.open(result.url, '_blank', '');
            })
            .catch(reason => {
                this.setState({ data: [], loading: false });
            });
    };

    /**
     * Clean filter form
     *
     * @param {type} event
     * @returns void
     */
    cleanFilters = event => {
        let dd = new Date();
        let filters = {
            clientLocator: '',
            reservationState: 'all', //vacio es todas
            dateType: 'FE',
            fromDate: moment(dd).subtract(7, 'days'),
            toDate: moment(dd).add(7, 'days'),
            clientName: '',
        };
        this.setState({ localizadorID: '', filters });
    };

    handleSubmit = event => {
        this.fetchBackendData();
    };

    fetchBackendData = () => {
        this.setState({ loading: true });
        listInvoices(this.state.filters)
            .then(data => {
                let id = 1;
                data.forEach(n => {
                    n.id = id++;
                });
                if (data) {
                    this.setState({
                        loading: false,
                        data: data,
                    });
                }

                localStorage.setItem('facturas', JSON.stringify(data));

            })
            .catch(reason => {
                this.setState({ data: [], loading: false });
            });
    };

    cantSearchById() {
        return this.state.localizadorID === '';
    }

    constructor(props) {
        super(props);

        this.pageName = 'Invoices';
        this.pageTitle = props.t('PAGE_TITLES.' + this.pageName);
        this.pageReference = 'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/621740036/UI+-+Mis+Reservas';

        let dd = new Date();
        this.state = {
            data: [],
            loading: false,
            localizadorID: '',
            filters: {
                clientLocator: '',
                reservationState: 'all', //vacio es todas
                dateType: 'FE',
                fromDate: moment(dd).subtract(7, 'days'),
                toDate: moment(dd).add(7, 'days'),
                clientName: '',
            },
        };
    }

    render() {
        const { classes, t } = this.props;
        return (
            <div>
                <ExpansionPanel defaultExpanded={true} style={{ marginTop: '0px' }} className={'thinText'}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon className={classes.expansionIcon} />}
                        className={classes.expansionPanelFilter}>
                        <Typography className={classes.filterTitle}>
                            {t('INVOICES.INVOICE_FINDER')}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{ padding: '0px' }}>
                        <div
                            className={classes.column}
                            style={{
                                backgroundColor: '#e5e5e5',
                                margin: '0 auto',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <Grid
                                container
                                direction="row"
                                style={{ padding: '20px 40px', margin: '0 auto', marginLeft: '24px' }}>
                                <TextField
                                    fullWidth
                                    label={t('INVOICES.OLYMPIA_LOCATOR')}
                                    value={this.state.localizadorID}
                                    onChange={event => {
                                        this.setState({
                                            localizadorID: String(event.target.value).toLocaleUpperCase(),
                                        });
                                    }}
                                    placeholder={t('INVOICES.INTRO_LOCATOR')}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.inputLabel,
                                    }}
                                />
                                <Button
                                    variant="raised"
                                    onClick={this.searchLocalizador}
                                    disabled={this.state.loading}
                                    color="secondary"
                                    fullWidth
                                    className={classes.button}
                                    style={{ margin: '0 auto', marginTop: '16px' }}>
                                    {t('INVOICES.SEARCH_INVOICES')}
                                </Button>
                            </Grid>
                        </div>

                        <div className={classes.columnall}>
                            <Grid container direction="row" spacing={24} style={{ padding: '32px' }}>
                                <Grid item xs={6} style={{ paddingLeft: '5%', minWidth: '50%' }}>
                                    <DropDownMenu
                                        label={t('INVOICES.STATE')}
                                        selection={this.state.filters.reservationState}
                                        onChange={value => {
                                            let filters = this.state.filters;
                                            filters.reservationState = value;
                                            this.setState({ filters });
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                            className: classes.inputLabel,
                                        }}
                                        width={'80%'}
                                        menuOptions={[
                                            { label: t('INVOICES.ALL'), value: 'all' },
                                            { label: t('INVOICES.PAYED'), value: 'Pagada' },
                                            { label: t('INVOICES.PARTLY_PAYED'), value: 'ParcialmentePagada' },
                                            { label: t('INVOICES.PENDING_STATE'), value: 'Pendiente' },
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <DatePicker
                                        keyboard
                                        onChange={value => {
                                            handleDateChange('fromDate', value, this);
                                        }}
                                        InputLabelProps={{
                                            className: classes.inputLabel,
                                        }}
                                        label={t('COMMON.FROM')}
                                        format={'DD/MM/YYYY'}
                                        value={this.state.filters.fromDate}
                                        autoOk
                                        style={{ width: '100%' }}
                                        leftArrowIcon={<LeftArrowIcon />}
                                        rightArrowIcon={<RightArrowIcon />}
                                        keyboardIcon={
                                            <EventIcon
                                                className={isEdge() ? classes.coloredIconIE : classes.coloredIcon}
                                            />
                                        }
                                        animateYearScrolling={false}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <DatePicker
                                        keyboard
                                        onChange={value => {
                                            handleDateChange('toDate', value, this);
                                        }}
                                        InputLabelProps={{
                                            className: classes.inputLabel,
                                        }}
                                        label={t('COMMON.TO')}
                                        format={'DD/MM/YYYY'}
                                        value={this.state.filters.toDate}
                                        autoOk
                                        style={{ width: '100%' }}
                                        leftArrowIcon={<LeftArrowIcon />}
                                        rightArrowIcon={<RightArrowIcon />}
                                        keyboardIcon={
                                            <EventIcon
                                                className={isEdge() ? classes.coloredIconIE : classes.coloredIcon}
                                            />
                                        }
                                        animateYearScrolling={false}
                                    />
                                </Grid>
                                <Grid item xs={6} />
                                <Grid item xs={6}>
                                    <TextField
                                        label={t('BOOKINGS.CLIENT_NAME')}
                                        value={this.state.filters.clientName}
                                        onChange={event => {
                                            let filters = this.state.filters;
                                            filters.clientName = event.target.value;
                                            this.setState({ filters });
                                        }}
                                        fullWidth
                                        placeholder={t('BOOKINGS.INSERT_NAME')}
                                        InputLabelProps={{
                                            shrink: true,
                                            className: classes.inputLabel,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} />
                                <Grid container item wrap="nowrap" spacing={8} xs={6}>
                                    <Grid container wrap="nowrap" spacing={8}>
                                        <Grid item xs={6} style={{ marginLeft: '0', marginRight: '12px' }}>
                                            <Button
                                                variant="raised"
                                                onClick={this.cleanFilters}
                                                disabled={this.state.loading}
                                                color="secondary"
                                                fullWidth>
                                                {t('INVOICES.CLEAN_FILTER_BUTTON')}
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button
                                                variant="raised"
                                                onClick={this.handleSubmit}
                                                disabled={this.state.loading}
                                                color="primary">
                                                {t('INVOICES.SEARCH_INVOICES')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <div style={{ margin: '5px' }}>
                    {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                    <InvoicesTable
                        data={this.state.data}
                        filters={this.state.filters}
                        actionhandler={this.tableActionsMenuHandler}
                        allowedActions={['PRINT']}
                        menuactionslabels={{
                            PRINT: t('INVOICES.PRINT_INVOICE')
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(Invoices));



// WEBPACK FOOTER //
// ./src/components/Invoices/Invoices.js